module.exports = __webpack_public_path__ + "static/img/1961_Originale_Kontakte_Cologne_10.ce26d74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1961_Originale_Kontakte_Cologne_10.jpg
// module id = BUYa
// module chunks = 0